// import { Components, TabsProps, Theme, alpha } from '@mui/material';

// export const MuiTabs: Components<Omit<Theme, 'components'>> = {
//   MuiTabs: {
//     styleOverrides: {
//       root: ({ ownerState, theme }) => ({
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         '& .MuiTab-root': {
//           fontFamily: 'unset',
//           fontWeight: 'unset',
//           fontSize: 'unset',
//           lineHeight: 'unset',
//           textTransform: 'unset',
//           whiteSpace: 'nowrap',
//         },
//         '&.filled': {
//           '& .MuiTab-root': {
//             backgroundColor: 'white',
//             border: `1px solid ${theme.palette.grey[200]}`,
//             padding: '0px 24px',
//             minHeight: '56px',
//           },
//           '& .MuiTypography-root': {
//             color: theme.palette.blue.main,
//           },
//           '& .Mui-selected': {
//             backgroundColor: alpha(theme.palette.primary.main, 0.1),
//           },
//           '& .MuiButtonBase-root:first-of-type': {
//             borderRadius: '12px 0px 0px 12px',
//             '&.singleItem': {
//               borderRadius: '12px 12px 12px 12px',
//             },
//           },
//           '& .MuiButtonBase-root:last-child': {
//             borderRadius: '0px 12px 12px 0px',
//             '&.singleItem': {
//               borderRadius: '12px 12px 12px 12px',
//             },
//           },
//         },
//         '&.flat': {
//           '& .MuiTab-root': {
//             padding: '9.5px 12px',
//             minHeight: '41px',
//           },
//           '& .Mui-selected': {
//             '& .MuiTypography-root': {
//               color: theme.palette.blue.main,
//             },
//           },
//         },
//         '& .Mui-disabled': {
//           '& .MuiTypography-root': {
//             color: theme.palette.grey[500],
//           },
//         },
//       }),
//       scrollButtons: ({ theme }) => ({
//         backgroundColor: theme.palette.white.main,
//         border: `1px solid ${theme.palette.grey[200]}`,
//         padding: '0px 12px',
//         minHeight: '56px',
//         '&.Mui-disabled': {
//           width: 0,
//           padding: 0,
//         },
//       }),
//       indicator: ({ ownerState }: { ownerState: TabsProps }) => [
//         {
//           ...(ownerState.className === 'filled' && { backgroundColor: 'inherit' }),
//         },
//       ],
//     },
//   },
// };

// MUI Imports
import type { Theme } from '@mui/material/styles';

const MuiTabs: Theme['components'] = {
  MuiTabs: {
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        minBlockSize: 38,
        '&.centered .MuiTabs-flexContainer': {
          justifyContent: 'center',
        },
        ...(ownerState.orientation === 'horizontal'
          ? {
              borderBlockEnd: '1px solid var(--mui-palette-divider)',
            }
          : {
              borderInlineEnd: '1px solid var(--mui-palette-divider)',
            }),
        // '& .MuiTab-root': {
        //   '&.flat': {
        //     paddingBlockEnd: theme.spacing(1.5),
        //   },
        // },
        '&.filled': {
          borderBlockEnd: 'none !important',
        },
        '&.tonal': {
          borderBlockEnd: 'none !important',
        },
        '& .MuiTab-root:not(.Mui-selected):hover': {
          ...(ownerState.textColor === 'secondary'
            ? {
                color: 'var(--mui-palette-secondary-main)',
              }
            : {
                color: 'var(--mui-palette-primary-main)',
              }),
          '& .MuiTabScrollButton-root': {
            borderRadius: 'var(--mui-shape-borderRadius)',
          },
        },
        '& ~ .MuiTabPanel-root': {
          ...(ownerState.orientation === 'horizontal'
            ? {
                paddingBlockStart: theme.spacing(5),
              }
            : {
                paddingInlineStart: theme.spacing(5),
              }),
        },
      }),
      scrollButtons: {
        '&.Mui-disabled': {
          width: 0,
          padding: 0,
        },
      },
      indicator: {
        '&.filled': {
          display: 'none !important',
        },
        '&.tonal': {
          display: 'none !important',
        },
      },
      vertical: {
        minWidth: 131,
        '& .MuiTab-root': {
          minWidth: 130,
        },
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        lineHeight: 1.4667,
        padding: theme.spacing(2, 5.5),
        minBlockSize: 44,
        '& > .MuiTab-iconWrapper': {
          fontSize: '1.125rem',
          ...(ownerState.iconPosition === 'start' && {
            marginInlineEnd: theme.spacing(1.5),
          }),
          ...(ownerState.iconPosition === 'end' && {
            marginInlineStart: theme.spacing(1.5),
          }),
        },
        '&.filled': {
          border: '1px solid var(--mui-palette-divider)',
          '&:first-of-type': {
            borderRadius: '8px 0px 0px 8px',
            '&.singleItem': {
              borderRadius: '8px',
            },
          },
          '&:last-child': {
            borderRadius: '0px 8px 8px 0px',
            '&.singleItem': {
              borderRadius: '8px',
            },
          },
          '&:not(:last-child)': {
            borderRight: 'none',
          },
          '&.Mui-selected': {
            color: 'var(--mui-palette-primary-contrastText)',
            backgroundColor: 'var(--mui-palette-primary-main)',
          },
          '&.tonal': {
            '&.Mui-selected': {
              color: 'var(--mui-palette-primary-contrastText)',
              backgroundColor: 'rgb(var(--mui-palette-primary-mainChannel) / 0.08)',
            },
          },
        },
        '&.tonal': {
          border: '1px solid rgb(var(--mui-palette-secondary-mainChannel) / 0.16)',
          color: 'var(--mui-palette-primary-main)',
          backgroundColor: 'var(--mui-palette-primary-contrastText)',
          borderRight: '0',
          '&:first-of-type': {
            borderRadius: '8px 0px 0px 8px',
            '&.singleItem': {
              borderRadius: '8px',
            },
          },
          '&:last-child': {
            borderRadius: '0px 8px 8px 0px',
            borderRight: '1px solid rgb(var(--mui-palette-secondary-mainChannel) / 0.16)',
            '&.singleItem': {
              borderRadius: '8px',
            },
          },
          '&.Mui-selected': {
            backgroundColor: 'rgb(var(--mui-palette-primary-mainChannel) / 0.08)',
            fontWeight: 600,
          },
        },
        // "&.Mui-selected.flat": {
        //   color: "var(--mui-palette-text-primary)",
        // },
      }),
    },
  },
  MuiTabPanel: {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  },
};

export default MuiTabs;
